module.exports = __webpack_public_path__ + "static/img/The_Songs_Button.5234b44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/The_Songs_Button.png
// module id = 740
// module chunks = 1